import { render, staticRenderFns } from "./ApiList.vue?vue&type=template&id=8223ca4c"
import script from "./ApiList.vue?vue&type=script&lang=js"
export * from "./ApiList.vue?vue&type=script&lang=js"
import style0 from "./ApiList.vue?vue&type=style&index=0&id=8223ca4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports